import LinksList from "@/components/Elements/LinksList";
import { useModelLink } from "@/modules/model-link";

const AssetTypesLinksList = ({ assetTypes }) => {
  const { getModelLink } = useModelLink();

  const links = assetTypes?.map((assetType) => ({
    label: assetType.name,
    to: getModelLink("assettype", assetType),
  }));

  return <LinksList links={links} />;
};

export default AssetTypesLinksList;
